module.exports = __webpack_public_path__ + "static/img/1-2.1e45687.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/1-2.png
// module id = 5B8P
// module chunks = 0